<cab-section-header class="header" [title]="'reviews.header' | translate" />
<div class="content">
  <div class="animation-container">
    @for (reviewItem of reviews; track $index) {
      <cab-review-card [reviewItem]="reviewItem" />
    }
  </div>
</div>
